import { ArrowRight, SlidersHorizontal } from "lucide-react";
import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ExperienceCover } from "../components/ExperienceCover";
import { ErrorState, LoadingState } from "../components/Feedback";
import { useCatalog } from "../hooks/useCatalog";
import { RatingSummary } from "../components/RatingSummary";

type Filter = "all" | "mystery" | "connection" | "party";

const labels: Record<Filter, string> = {
  all: "Cualquier emoción",
  mystery: "Suspenso",
  connection: "Conexión",
  party: "Risa"
};

export function CatalogPage() {
  const { items, loading, error, reload } = useCatalog();
  const [filter, setFilter] = useState<Filter>("all");
  const filtered = useMemo(() => items.filter((item) => filter === "all" || item.format === filter), [items, filter]);

  if (loading) return <LoadingState label="Abriendo el catálogo…" />;
  if (error) return <ErrorState message={error} onRetry={reload} />;

  return (
    <div className="catalog-page page-pad">
      <header className="catalog-heading">
        <h1>Elijan por cómo quieren que se sienta la noche.</h1>
        <p>No hay biblioteca infinita. Hay {items.length} experiencias distintas, cada una con un final claro y lista para empezar.</p>
      </header>
      <div className="filter-row" aria-label="Filtrar catálogo">
        <SlidersHorizontal aria-hidden="true" />
        {Object.entries(labels).map(([value, label]) => (
          <button
            key={value}
            type="button"
            className={filter === value ? "filter-chip is-active" : "filter-chip"}
            aria-pressed={filter === value}
            onClick={() => setFilter(value as Filter)}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="catalog-list">
        {filtered.map((item, index) => (
          <article className={`catalog-row catalog-row-${index + 1}`} key={item.id}>
            <ExperienceCover item={item} />
            <div className="catalog-row-copy">
              <h2>{item.title}</h2>
              <RatingSummary summary={item.ratingSummary} />
              <p className="catalog-tagline">{item.tagline}</p>
              <p>{item.description}</p>
              <dl className="facts-line">
                <div><dt>Tiempo</dt><dd>{item.estimatedMinutes} min</dd></div>
                <div><dt>Personas</dt><dd>{item.minPlayers === item.maxPlayers ? item.minPlayers : `${item.minPlayers}–${item.maxPlayers}`}</dd></div>
                <div><dt>Intensidad</dt><dd>{item.intensity}</dd></div>
              </dl>
            </div>
            <div className="catalog-row-action">
              <strong>${item.priceMxn} <small>MXN / grupo</small></strong>
              <Link className="button button-ink" to={`/experiencias/${item.slug}`}>Ver experiencia <ArrowRight aria-hidden="true" /></Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
